import 'store/bolt/homeEntLoader';
import Store from 'store/store';
import { openSidePanel } from 'store/bolt/sidePanelLoader';

Store.on('HOMEENT_SHOW', (animate, queryString, pageId) => {
	const store = Store.get();
	if (!pageId) {
		const pages = store.appData?.pages || {};
		const aHomeEntPage = Object.values(pages).find(page => page.type === 'homeEnt');
		pageId = aHomeEntPage?.id;
	}

	let returnTo = store.activePage;
	if (pageId && returnTo === pageId) {
		// Landing directly on a homeEnt page - assume there is a matching event page
		returnTo = pageId.replace(/-homeEnt$/i, '');
	}
	store.homeEnt.set({ returnToPage: returnTo });
	store.showtimes.set({ returnToPage: returnTo });
	
	openSidePanel(animate, 'homeEnt', false, queryString, pageId);
});
